"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAclParser = void 0;

var userAclParser = function () {
  // let getPermissionsList = (aclRoles) => {
  //   return aclRoles.acl_roles.reduce(
  //     (acc, curr) => [...acc, ...curr.acl_permissions],
  //     []
  //   );
  // };
  // let getScopesFromAclRoles = (aclRoles) => {
  //   let permissions = getPermissionsList(aclRoles);
  //   let scopes = permissions
  //     .reduce((acc, curr) => acc + " " + curr.scope, "")
  //     .trim()
  //     .split(" ");
  //   return [...new Set(scopes)];
  // };
  var getScopes = function getScopes(tokenInfo) {
    var merchants = tokenInfo["merchants"];
    return merchants[Object.keys(merchants)[0]].scopes;
  };

  return {
    getScopes: getScopes
  };
}();

exports.userAclParser = userAclParser;